import { createRouter, createWebHistory } from 'vue-router'

import HomeView from '@/views/Home.vue'
import AboutView from '@/views/About.vue'
import VendorsView from '@/views/Vendors.vue'
import VendorDetailView from '@/views/VendorDetail.vue'
import VendorSearchView from '@/views/VendorSearch.vue'
import VenueSearchView from '@/views/VenueSearch.vue'
import VenuesView from '@/views/Venues.vue'
import VendorSignupView from '@/views/vendors/VendorSignup.vue'
import VendorOnboardView from '@/views/vendors/VendorOnboard.vue'
import CategoriesView from '@/views/Categories.vue'
import BlogView from '@/views/Blog.vue'
import BlogDetailView from '@/views/BlogDetail.vue'
import ContactView from '@/views/Contact.vue'
import PrivacyPolicyView from '@/views/PrivacyPolicy.vue'
import TermsView from '@/views/Terms.vue'
import UseCasesView from '@/views/UseCases.vue'
import UseCaseDetailView from '@/views/UseCaseDetail.vue'
import FaqsView from '@/views/Faqs.vue'
import PricingView from '@/views/Pricing.vue'
import LoginView from '@/views/Login.vue'
import ForgotPasswordView from '@/views/ForgotPassword.vue'
import DashboardLayoutView from '@/views/vendors/DashboardLayout.vue'
import DashboardHomeView from '@/views/vendors/DashboardHome.vue'
import DashboardVenuesView from '@/views/vendors/DashboardVenues.vue'
import DashboardPackagesView from '@/views/vendors/DashboardPackages.vue'
import DashboardSettingsView from '@/views/vendors/DashboardSettings.vue'
import AddVenueView from '@/views/vendors/AddVenue.vue'
import EditVenueView from '@/views/vendors/EditVenue.vue'
import AddPackageView from '@/views/vendors/AddPackage.vue'
import EditPackageView from '@/views/vendors/EditPackage.vue'
import { isAuthenticated } from '@/services/auth'

const routes = [ 
    { path: '/', name: 'home', component: HomeView },
    { path: '/about', name: 'about', component: AboutView },
    { path: '/vendors', name: 'vendors', component: VendorsView },
    { path: '/vendors/:slug', name: 'vendors-slug', component: VendorsView },
    { path: '/vendor/:id', name: 'vendor-detail', component: VendorDetailView },
    { path: '/vendor-search', name: 'vendor-search', component: VendorSearchView },
    { path: '/venue-search', name: 'venue-search', component: VenueSearchView },
    { path: '/venues', name: 'venues', component: VenuesView },
    { path: '/venues/:slug', name: 'venues-slug', component: VenuesView },
    { path: '/vendor-signup', name: 'vendor-signup', component: VendorSignupView },
    { path: '/vendor-onboard',  name: 'vendor-onboard', component: VendorOnboardView },
    { path: '/categories', name: 'categories', component: CategoriesView },
    { path: '/blog', name: 'blog', component: BlogView },
    { path: '/blog/:slug', name: 'blog-detail', component: BlogDetailView },
    { path: '/contact', name: 'contact', component: ContactView },
    { path: '/privacy-policy', name: 'privacy-policy', component: PrivacyPolicyView },
    { path: '/terms', name: 'terms', component: TermsView },
    { path: '/use-cases/:slug', name: 'use-case-detail', component: UseCaseDetailView },
    { path: '/use-cases', name: 'use-cases', component: UseCasesView },
    { path: '/faqs', name: 'faqs', component: FaqsView },
    { path: '/pricing', name: 'pricing', component: PricingView },
    { path: '/login', name: 'login', component: LoginView },
    { path: '/register', name: 'register', component: VendorSignupView },
    { path: '/forgot-password', name: 'forgot-password', component: ForgotPasswordView },
    {
      path: '/dashboard',
      component: DashboardLayoutView,
      meta: { requiresAuth: true },
      children: [
        { path: '', name: 'dashboard', component: DashboardHomeView },
        { path: 'venues', name: 'dashboard-venues', component: DashboardVenuesView },
        { path: 'packages', name: 'dashboard-packages', component: DashboardPackagesView },
        { path: 'settings', name: 'dashboard-settings', component: DashboardSettingsView },
        { path: 'add-venue', name: 'add-venue', component: AddVenueView },
        { path: 'edit-venue/:id', name: 'edit-venue', component: EditVenueView },
        { path: 'add-package', name: 'add-package', component: AddPackageView },
        { path: 'edit-package/:id', name: 'edit-package', component: EditPackageView }
      ]
    },
    { path: '/:pathMatch(.*)*',  name: 'NotFound', component: () => import('@/views/NotFound.vue') }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !isAuthenticated()) {
    next({ name: 'login', query: { redirect: to.fullPath } })
    return
  }
  next()
})

export default router
